export default "__VITE_ASSET__D5kSJkbH__"